export const removeEmptyParams = (obj: any) =>
  Object.fromEntries(
    // eslint-disable-next-line
    Object.entries(obj).filter(([_, v]) => v !== null && v !== '')
  );
